
export interface PlanesCorporativosResp {
  count: number
  next: any
  previous: any
  numero_paginas: number
  data: PlanesCorporativos[]
}

export interface PlanesCorporativos {
  id_plan_coorporativo?: string;
  codigo?: string;
  numero_referencia?: string;
  estado?: boolean;
  nombre: string;
  tipo_plan: TipoPlanCorporativo;
  permanencia: PermanenciaPlanCorporativo | string;
  costo_instalacion: number;
  valor: number;
  capacidad: number;
  fecha_creacion?: Date;
  fecha_modificacion?: Date;
  plan_personalizado?: boolean
}

export enum ServicioCanejeEvento {
  HOME = 'HOGAR'
}

export enum TipoPlanCorporativo {
  ISP = "ISP",
  CORPORATIVO = "CORPORATIVO",
  CORPORATIVO2 = "CORPORATIVO-2",
  INSTITUCIONALES = "INSTITUCIONALES",
  PYME = "PYME",
  XPON = "XPON 2:1",
  BACKUP_CON_COSTO = "BACKUP CON COSTO",
  DEMO = "DEMO",
  DEMO_CORPORATIVO = "DEMO CORPORATIVO",
  DEMO_CORPORATIVO2 = "DEMO CORPORATIVO-2",
  DEMO_ISP = "DEMO ISP",
  DEMO_INSTITUCIONALES = "DEMO INSTITUCIONALES",
  DEMO_XPON = "DEMO XPON 2:1",
  EVENTO_PAGADO = "EVENTO PAGADO",
  EVENTO_GRATUITO = "EVENTO GRATUITO",
  CANJE = "CANJE",
}
export const TIPO_PLAN_CORPORATIVO_CHOICE = [
  TipoPlanCorporativo.ISP,
  TipoPlanCorporativo.CORPORATIVO,
  TipoPlanCorporativo.CORPORATIVO2,
  TipoPlanCorporativo.INSTITUCIONALES,
  //Pyme ya no se usa en corporativo para dejar paso a planes home, jaja ya se usa saludos xd
  // TipoPlanCorporativo.PYME,
  TipoPlanCorporativo.XPON,
  TipoPlanCorporativo.DEMO,
  TipoPlanCorporativo.BACKUP_CON_COSTO,
  TipoPlanCorporativo.DEMO_CORPORATIVO,
  TipoPlanCorporativo.DEMO_CORPORATIVO2,

  TipoPlanCorporativo.DEMO_ISP,
  TipoPlanCorporativo.DEMO_INSTITUCIONALES,
  TipoPlanCorporativo.DEMO_XPON,
  TipoPlanCorporativo.EVENTO_PAGADO,
  TipoPlanCorporativo.EVENTO_GRATUITO,
  TipoPlanCorporativo.CANJE,
];

export enum PermanenciaPlanCorporativo {
  MESES_12 = "12 MESES",
  MESES_24 = "24 MESES",
  MESES_36 = "36 MESES",
  MESES_48 = "48 MESES",
  MESES_60 = "60 MESES",
}
export const PERMANENCIA_PLAN_CORPORATIVO_CHOICE = [
  PermanenciaPlanCorporativo.MESES_12,
  PermanenciaPlanCorporativo.MESES_24,
  PermanenciaPlanCorporativo.MESES_36,
  PermanenciaPlanCorporativo.MESES_48,
  PermanenciaPlanCorporativo.MESES_60,
];
// export type TipoPlanCorporativo = "ISP"| "CORPORATIVO"| "INSTITUCIONALES"| "PYME"| "DEMO";
// export type PermanenciaPlanCorporativo = "12 MESES"| "24 MESES"| "36 MESES"| "48 MESES"| "60 MESES";

export interface PlanesCorporativosParams extends Partial<PlanesCorporativos> {
  page?: number
  page_size?: number
  codigo?: string;
}


export interface PlanesCorporativosForm {
  id_plan_coorporativo?: string;
  codigo?: string;
  numero_referencia?: string;
  estado?: boolean;
  nombre: string;
  tipo_plan: TipoPlanCorporativo;
  permanencia?: PermanenciaPlanCorporativo | string;
  costo_instalacion: number;
  valor: number;
  capacidad: number;
  plan_personalizado?: boolean
}